import { Injectable } from '@angular/core';
import { ConfHttpService } from './conf-http.service';
import { AuthService } from '../CookieAuth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Cliente } from '../interfaces/cliente';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  endpopint:string='';
  constructor(private http:HttpClient, private cookie: AuthService, conf:ConfHttpService) {
    this.endpopint=conf.getBackend();
   }

  postCliente(cliente: Cliente){
    return this.http.post<Cliente>(this.endpopint+'newcliente', cliente,{headers: this.headers}).toPromise();
  }

  activar(id: string){
    return this.http.post<any>(this.endpopint+'clienteactivar/'+ id,{headers: this.headers}).toPromise();
  }
  put(cliente: Cliente){

  }
  getbytoken(){
    return this.http.get<any>(this.endpopint+'getbytoken/'+ this.cookie.getCookie(),{headers: this.headers}).toPromise();
  }
}
